const configItem = {
    item: {
        listLayout: 'ItemListDefaultLayout',
        filterLayout: 'ItemFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getItem',
        listApiParamSet: {
            type: 'sub',
            ty:'sub',
            ip: 1,
        },
        deleteFunc: 'deleteItem',
        deleteApiParamsSet: {type: 'sub'},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-1': "DB에러.",
            '-100': "필수값 없음.",
            '-404': "객체없음.",
        },
        keyName: 'i_idx',
    },
    create: {
        writeLayouts: ['ItemWriteDefaultLayout'],
        writeFunc: 'createItem',
        writeApiParamSet: {
            type: 'sub',

        },
        parsingData: {
            title: 'i_name',
            seq: 'i_seq',
            type:'is_cycle_type',
            time:'is_cycle_time',
            price:'i_price',
        },
        writeSuccessType: 1,
        writeFailTypes: {
            // '-1': "선택하신 카테고리는 삭제된 카테고리입니다.",
            // '-100': "제목이 중복되었습니다.",
        },
        directType:'back',
    },
    update: {
        writeLayouts: ['ItemWriteDefaultLayout'],
        getFunc: 'getItem',
        detailApiParamsSet: {type: 'sub'},
        getDetailParamsKey: 'id',
        writeFunc: 'updateItem',
        writeApiParamSet: {
            type: 'sub',
        },
        parsingData: {
            title: 'i_name',
            seq: 'i_seq',
            type:'is_cycle_type',
            time:'is_cycle_time',
            price:'i_price',
        },
        directUrl: '',
        directType: '',
        writeSuccessType: 1,
        writeFailTypes: {
            // '-1': "DB에러",
            // '-100': "선택하신 카테고리는 삭제된 카테고리입니다.",
            // '-404': "데이터가 없습니다.",
        },
        keyName: 'i_idx',
        deleteFunc: 'deleteItem',
        deleteApiParamsSet: {type: 'sub'},
        deleteSuccessType: 1,
        deleteFailTypes: {
            '-1': "DB에러.",
            '-100': "필수값 없음.",
            '-404': "객체없음.",
        },
    },
}

export default {
    methods: {
        returnItemConfig(type) {
            return configItem[type];
        }
    },
    filterConfig: {
        cr: { //작성일
            type: 'between',
            classname: 'filterDate'
        },
        na: { //제목
            type: 'query',
            classname: 'searchInput',
        },
    }
}
